import { useState } from 'react';
import { Button, Badge } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import MismoUploadModal from './MismoUploadModal';

const MismoUpload = () => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const toggleIsOpenModal = () => setIsOpenModal(prev => !prev)

  return (
    <div style={{ marginTop: '8px' }}>
      <Badge
        count="NEW"
        style={{ background: '#1E0C68', fontSize: '10px' }}
        offset={[10, -4]}
      >
        <Button
          type="ghost"
          size="small"
          icon={<UploadOutlined />}
          onClick={toggleIsOpenModal}
        >
          MISMO 3.4 UPLOAD
        </Button>
      </Badge>

      <MismoUploadModal
        isOpen={isOpenModal}
        onClose={toggleIsOpenModal}
      />
    </div>
  );
};

export default MismoUpload;
